import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      welcome: "Welcome to MIC Green Store",
      home: "Home",
      items: "Items",
      cart: "Cart",
      register: "Register",
      login: "Login",
      logout: "Logout",
      language: "Language",
      currency: "Currency",
      addToCart: "Add to Cart",
      removeFromCart: "Remove from Cart",
      price: "Price",
      description: "Description",
      quantity: "Quantity",
      total: "Total",
      checkout: "Checkout",
      emptyCart: "Your cart is empty",
      itemDetails: "Item Details",
      backToItems: "Back to Items",
      registerForm: "Registration Form",
      loginForm: "Login Form",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      firstName: "First Name",
      lastName: "Last Name",
      submit: "Submit",
      alreadyHaveAccount: "Already have an account?",
      dontHaveAccount: "Don't have an account?",
      signUp: "Sign Up",
      signIn: "Sign In",
      electronics: "Electronics",
      clothing: "Clothing",
      books: "Books",
      homeGarden: "Home & Garden",
      sports: "Sports",
      beauty: "Beauty",
      shareOnSocial: "Share on Social Media",
      availableInStock: "Available in Stock",
      deliveryIn10Days: "Delivery within 10 days",
      pay50Percent: "Pay 50%",
      outOfStock: "Out of Stock",
      limitedStock: "Limited Stock",
      inStock: "In Stock",
      partialPayment: "Partial Payment",
      quantityPricing: "Quantity Pricing",
      minimumOrder: "Minimum Order",
      externalOrder: "External Order",
      video: "Video",
      day: "day",
      more: "more",
      searchPlaceholder: "What are you looking for?",
      importRequest: "Import Request",
      request: "Request",
      USD_name: "US Dollar",
      EUR_name: "Euro",
      SAR_name: "Saudi Riyal",
      AED_name: "UAE Dirham",
      SDG_name: "Sudanese Pound",
      arabic: "Arabic",
      english: "English",
      cartText: "Cart",
      homeText: "Home",
      loginText: "Login",
      hideFilters: "Hide Filters",
      showAllProducts: "Show All Products",
      allCategories: "All Categories",
      showProductsOf: "Show products of",
      welcomeBack: "Welcome back! Login to your account",
      loginIdentifierLabel: "Username, Email or Mobile",
      loginIdentifierPlaceholder: "Enter Username, Email or Mobile",
      passwordPlaceholder: "Enter Password",
      loggingIn: "Logging in...",
      loginErrorInvalid: "Invalid username, email, mobile or password",
      loginErrorGeneric: "Error occurred during login",
      registerErrorPasswordMismatch: "Passwords do not match",
      registerErrorFailed: "Registration failed. Please try again",
      registerErrorGeneric: "Error occurred during registration",
      factoryToDoor: "Factory to Door",
      productionLines: "Production Lines",
      chinaSuppliers: "Trusted China Suppliers",
      fullService: "Full Service",
      onDemand: "On Demand",
      bestPrice: "Best Price",
      enterProductName: "Please enter product name",
      enterValidQuantity: "Please enter a valid quantity",
      loginToContinueRequest: "Please login to complete your request",
      requestFailed: "Failed to send request",
      validationErrors: "Validation errors",
      errorPrefix: "Error",
      errorSendingRequest: "Error occurred while sending request",
      addToCartWithQty: "Add to Cart ({{count}} unit)",
      createAccountMsg: "Create your account to start shopping",
      loginToCheckout: "Login to checkout",
      sessionExpired: "Session Expired",
      sessionExpiredMsg: "Session expired. Please login again",
      orderFailed: "Order Failed",
      minOrderQuantity: "Minimum Order Quantity: {{count}} unit",
      notAvailable: "Not Available",
      wholesale: "Wholesale",
      chooseQuantityMsg: "Choose your quantity and get the best price",
      clickRowMsg: "Click on any row to select and get preferred prices",
      targetQuantity: "Quantity",
      unitPrice: "Unit Price",
      totalPrice: "Total",
      unit: "Unit",
      discount: "Discount",
      chooseQuantity: "Choose Quantity",
      savings: "Savings",
      specialPrices: "Special Prices Applied",
      andMore: "and more",
      cancel: "Cancel",
      savedRequestErrorGeneric: "Error occurred while sending saved request",
      footerDesc: "Your trusted store for high-quality products at great prices",
      aboutStore: "About Store",
      aboutUs: "About Us",
      contactUs: "Contact Us",
      careers: "Careers",
      blog: "Blog",
      help: "Help",
      helpCenter: "Help Center",
      shippingDelivery: "Shipping & Delivery",
      returnsExchange: "Returns & Exchange",
      faq: "FAQ",
      legal: "Legal",
      privacyPolicy: "Privacy Policy",
      termsConditions: "Terms & Conditions",
      cookiePolicy: "Cookie Policy",
      legalInfo: "Legal Information",
      followUs: "Follow Us",
      subscribeNewsletter: "Subscribe to Newsletter",
      enterEmailPlaceholder: "Enter your email",
      allRightsReserved: "All rights reserved.",
      paymentMethodsAccepted: "Accepted Payment Methods:",
      firstNamePlaceholder: "Enter First Name",
      lastNamePlaceholder: "Enter Last Name",
      userNamePlaceholder: "Enter Username",
      emailPlaceholder: "Enter Email",
      mobilePlaceholder: "Enter Mobile Number (e.g. 0501234567)",
      passwordRegisterPlaceholder: "Enter Password (at least 6 characters)",
      confirmPasswordPlaceholder: "Re-enter Password",
      creatingAccount: "Creating Account...",
      shoppingCart: "Shopping Cart",
      addItemsToStart: "Add some items to start shopping!",
      backToShopping: "Back to Shopping",
      image: "Image",
      itemName: "Product Name",
      action: "Action",
      priceAdjusted: "Price Adjusted",
      clearCart: "Clear Cart",
      copied: "Copied!",
      linkCopied: "Product link copied to clipboard",
      clickToZoom: "Click to Zoom",
      productVideo: "Product Video",
      watchVideoDesc: "Watch product video from all angles",
      addedToCart: "Added to Cart",
      requestForm: "Request Form",
      requestType: "Request Type",
      supplyRequest: "Supply Request",
      shippingRequest: "Shipping Request",
      productNamePlaceholder: "Enter product name",
      specifications: "Specifications",
      specificationsPlaceholder: "Enter product specifications (Size, Color, Model, etc...)",
      requestedQuantity: "Requested Quantity",
      additionalNotes: "Additional Notes",
      additionalNotesPlaceholder: "Any additional info that might help us...",
      submitRequest: "Submit Request",
      sending: "Sending...",
      requestSentSuccess: "Request sent successfully!",
      requestSentDesc: "Thank you! Your request will be reviewed and we will respond shortly.",
      redirectingToHome: "Redirecting to Home...",
      days: "days",
      sourceChina: "Source from China",
      sourceGulf: "Source from Gulf",
      savedRequestError: "Failed to send saved request. Please try again.",
      startYourRequestNow:"start Your Request Now",
      userName: "User Name",
      mobileNumber: "Mobile Number",
      countryCode: "Country Code",
      saudiArabia: "Saudi Arabia",
      sudan: "Sudan",
      enterMobileDigits: "Enter mobile digits (without country code)",
      mobileDigitsOnly: "Digits only are allowed",
      mobileLengthInvalid: "Digits must be {{count}}",
      notRegisteredPrompt: "Login failed. If you don't have an account with this number, please register.",
      completeRegistration: "Complete Registration",
      mobileOnlyLoginWarning: "Note: Login with mobile number only is less secure without OTP verification. We recommend using a password.",
      addNewItem: "Add New Item",
      addNewItemToStore: "Add New Item to Store",
      category: "Category",
      item: "Item",
      storeInfo: "Store Info",
      itemAddedSuccess: "Item added to store successfully!",
      step1AddCategory: "Step 1: Add New Category",
      categoryName: "Category Name",
      categoryNameEn: "Category Name (English)",
      icon: "Icon",
      color: "Color",
      displayOrder: "Display Order",
      nextAddItem: "Next: Add Item",
      step2AddItem: "Step 2: Add New Item",
      itemCode: "Item Code",
      previous: "Previous",
      nextStoreInfo: "Next: Store Info",
      step3StoreInfo: "Step 3: Item Store Info",
      selectCurrency: "Select Currency",
      stockQuantity: "Stock Quantity",
      minStockLevel: "Minimum Stock Level",
      maxStockLevel: "Maximum Stock Level",
      leadTimeDays: "Lead Time (Days)",
      available: "Available",
      featured: "Featured",
      videoUrl: "Video URL",
      addItemToStoreBtn: "Add Item to Store",
      createCategoryFailed: "Failed to create category",
      createCategoryError: "Error creating category",
      createItemFailed: "Failed to create item",
      createItemError: "Error creating item",
      mustCreateItemFirst: "Must create item first",
      addItemToStoreFailed: "Failed to add item to store",
      addItemToStoreError: "Error adding item to store",
      requestNewProduct: "Request New Product",
      requestNewProductDesc: "Request a new product from MIC Green Store",
      previousRequests: "Previous Requests",
      noRequestsFound: "No requests found",
      requestDate: "Date",
      status: "Status",
      fetchItemsError: "Error fetching store items",
      featuredProducts: "Featured Products",
      featuredProductsDesc: "We chose the best products for you",
      viewAll: "View All",
      showingCount: "Showing {{count}} products",
      sortByNewest: "Sort by: Newest",
      sortByPriceLowToHigh: "Sort by: Price (Low to High)",
      sortByPriceHighToLow: "Sort by: Price (High to Low)",
      sortByBestSelling: "Sort by: Best Selling",
      heroMissionText: "We are your trade bridge and support in choosing the best products from around the world to build a more beautiful Sudan together",
      productAvailable: "Product Available",
      safeImport: "Safe Import",
      fast: "Fast",
      deliveryIn30Days: "Delivery in 30 days",
      freeShipping: "Free Shipping",
      freeShippingDesc: "For all orders over 500 SAR",
      buyerProtection: "Buyer Protection",
      qualityGuarantee: "Quality Assurance & Exchange",
      customerService247: "24/7 Customer Service",
      Support: "Support",
      easyReturn: "Easy Return",
      within30Days: "Within 30 days of purchase",
      errorOccurred: "An error occurred",
      allProducts: "All Products",
      customProductRequest: "Custom Product Request",
      yourPartnerInGlobal: "Your partner in choosing the best global products",
      instantQuote: "Instant quote within 24 hours",
      step1Title: "Send Your Request",
      step1Desc: "Product Name and Specifications",
      step2Title: "Price Quote",
      step2Desc: "We send you the best offer",
      step3Title: "Supply",
      step3Desc: "We ship to your door",
      
      // Item Details
      priceLabel: "Price",
      regularPrice: "Regular Price",
      quantityPrices: "Quantity Prices",
      selectQuantityForBestPrice: "Select quantity to get the best price",
      quantityLabel: "Quantity:",
      unitPriceLabel: "Unit Price:",
      totalPriceLabel: "Total Price:",
      quantityHeader: "Quantity",
      unitPriceHeader: "Unit Price",
      totalPriceHeader: "Total Price",
      piece: "Piece",
      quantityDiscountNote: "The more quantity you buy, the lower the unit price",
      availableQuantity: "Available Quantity",
      minimumLimit: "Minimum Limit",
      minOrderQuantityLabel: "Minimum Order Quantity",
      externalOrderLabel: "External Order:",
      productAvailableWithin: "Product will be available within",
      businessDays: "business days",
      delivery: "Delivery",
      within: "Within",
      payment: "Payment",
      shareLink: "Share Link",
      metaTitle: "MIC Green - Supply solutions in all fields especially solar and green energy",
      metaDescription: "MIC Green – Leaders in renewable energy and battery solutions",
      metaTwitterTitle: "MIC Green - Solar and Green Energy Solutions",
      previousOrders: "Previous Orders",
      orderNumber: "Order #",
      noOrdersFound: "No previous orders found",
      productName: "Product Name",
      orderSuccess: "Order Placed Successfully",
      loginRequired: "Login Required",
      minOrderQuantityMessage: "Minimum order quantity for this item is {{min}}.",
      customerIdRequired: "Customer information is missing",
      customerIdRequiredMsg: "Unable to complete order because customer information is missing. Please try logging out and logging in again.",
      bankTransfer: "Bank Transfer",
      cash: "Cash",
    //  clearCart: "Clear Cart",
      subtotal: "Subtotal",
      proceedToCheckout: "Proceed to Checkout",
      shippingMethod: "Shipping Method",
      noShippingMethods: "No shipping methods available",
      weAccept: "We Accept",
      orderType: "Order Type",
      externalOrderType: "External Order",
      internalOrderType: "Internal Order",
      shippingPerItem: "Shipping per item",
      shippingDays: "Shipping days",
      paymentMethodRequired: "Payment Method Required",
      selectPaymentMethodMsg: "Please select a payment method",
      splitIn4: "Split in 4 payments of {{amount}}",
      payInInstallments: "Pay in installments",
      calculating: "Calculating...",
      free: "Free",
      paymentMethod: "Payment Method",
      noPaymentMethods: "No payment methods available",
      orderSummary: "Order Summary",
      shippingCost: "Shipping Cost",
      placeOrder: "Place Order",
      secureCheckout: "Secure Checkout",
      loading: "Loading...",
      actions: "Actions",
      ok: "OK",
      // actions: "Actions",
      // ok: "OK",
    }
  },
  ar: {
    translation: {
      welcome: "مرحباً بك في متجر MIC Green",
      home: "الرئيسية",
      user: "مستخدم",
      items: "المنتجات",
      cart: "السلة",
      shoppingCart: "سلة التسوق",
      register: "تسجيل",
      login: "تسجيل الدخول",
      logout: "تسجيل الخروج",
      language: "اللغة",
      currency: "العملة",
      addToCart: "أضف إلى السلة",
      removeFromCart: "احذف من السلة",
      price: "السعر",
      description: "الوصف",
      quantity: "الكمية",
      total: "المجموع",
      checkout: "الدفع",
      emptyCart: "سلتك فارغة",
      itemDetails: "تفاصيل المنتج",
      backToItems: "العودة للمنتجات",
      registerForm: "نموذج التسجيل",
      loginForm: "نموذج تسجيل الدخول",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      confirmPassword: "تأكيد كلمة المرور",
      firstName: "الاسم الأول",
      lastName: "الاسم الأخير",
      submit: "إرسال",
      alreadyHaveAccount: "لديك حساب بالفعل؟",
      dontHaveAccount: "ليس لديك حساب؟",
      signUp: "إنشاء حساب",
      signIn: "تسجيل الدخول",
      electronics: "إلكترونيات",
      clothing: "ملابس",
      books: "كتب",
      homeGarden: "المنزل والحديقة",
      sports: "رياضة",
      beauty: "جمال",
      shareOnSocial: "مشاركة رابط المنتج",
      availableInStock: "متوفر في المخزن",
      deliveryIn10Days: "توصيل خلال 10 أيام من الطلب",
      pay50Percent: "دفع 50%",
      outOfStock: "نفد من المخزن",
      limitedStock: "مخزون محدود",
      inStock: "متوفر",
      partialPayment: "دفع جزئي",
      quantityPricing: "أسعار الكميات",
      minimumOrder: "الحد الأدنى",
      externalOrder: "طلب خارجي",
      video: "فيديو",
      day: "يوم",
      more: "أكثر",
      searchPlaceholder: "ما الذي تبحث عنه؟",
      importRequest: "طلب استيراد",
      request: "طلب",
      USD_name: "دولار أمريكي",
      EUR_name: "يورو",
      SAR_name: "ريال سعودي",
      AED_name: "درهم إماراتي",
      SDG_name: "جنيه سوداني",
      arabic: "العربية",
      english: "الإنجليزية",
      footerDesc: "متجرك الموثوق للمنتجات عالية الجودة بأسعار مميزة",
      aboutStore: "عن المتجر",
      aboutUs: "من نحن",
      contactUs: "اتصل بنا",
      careers: "الوظائف",
      blog: "المدونة",
      help: "المساعدة",
      helpCenter: "مركز المساعدة",
      shippingDelivery: "الشحن والتسليم",
      returnsExchange: "الإرجاع والاستبدال",
      faq: "الأسئلة الشائعة",
      legal: "الشؤون القانونية",
      privacyPolicy: "سياسة الخصوصية",
      termsConditions: "الشروط والأحكام",
      cookiePolicy: "سياسة ملفات تعريف الارتباط",
      legalInfo: "معلومات قانونية",
      followUs: "تابعنا",
      subscribeNewsletter: "اشترك في النشرة البريدية",
      enterEmailPlaceholder: "أدخل بريدك الإلكتروني",
      allRightsReserved: "جميع الحقوق محفوظة.",
      paymentMethodsAccepted: "طرق الدفع المقبولة:",
      cartText: "سلة",
      homeText: "الرئيسية",
      loginText: "دخول",
      hideFilters: "إخفاء التصفية",
      showAllProducts: "عرض جميع المنتجات",
      allCategories: "جميع الفئات",
      showProductsOf: "عرض منتجات",
      welcomeBack: "مرحباً بعودتك! سجل الدخول إلى حسابك",
      loginIdentifierLabel: "اسم المستخدم أو البريد الإلكتروني أو رقم الجوال",
      loginIdentifierPlaceholder: "أدخل اسم المستخدم أو البريد الإلكتروني أو رقم الجوال",
      customerIdRequired: "بيانات العميل مفقودة",
      customerIdRequiredMsg: "لا يمكن إتمام الطلب لعدم توفر بيانات العميل. يرجى تسجيل الخروج ثم الدخول مرة أخرى.",
      noShippingMethods: "لا توجد طرق شحن متاحة",
      noPaymentMethods: "لا توجد طرق دفع متاحة",
      splitIn4: "قسّطها على 4 دفعات بقيمة {{amount}}",
      payInInstallments: "ادفع بالتقسيط",
      shippingMethodRequired: "طريقة الشحن مطلوبة",
      selectShippingMethodMsg: "يرجى اختيار طريقة الشحن",
      paymentMethodRequired: "طريقة الدفع مطلوبة",
      selectPaymentMethodMsg: "يرجى اختيار طريقة الدفع",
      weAccept: "نقبل الدفع عبر",
      bankTransfer: "تحويل بنكي",
      passwordPlaceholder: "أدخل كلمة المرور",
      loggingIn: "جاري تسجيل الدخول...",
      loginErrorInvalid: "اسم المستخدم أو البريد الإلكتروني أو رقم الجوال أو كلمة المرور غير صحيحة",
      loginErrorGeneric: "حدث خطأ أثناء تسجيل الدخول",
      registerErrorPasswordMismatch: "كلمات المرور غير متطابقة",
      registerErrorFailed: "فشل التسجيل. يرجى المحاولة مرة أخرى",
      errorOccurred: "حدث خطأ",
      registerErrorGeneric: "حدث خطأ أثناء التسجيل",
      factoryToDoor: "من المصنع إلى بابك",
      productionLines: "استيراد خطوط إنتاج",
      chinaSuppliers: "موردون موثوقون من الصين",
      fullService: "خدمة متكاملة",
      onDemand: "حسب الطلب",
      bestPrice: "أفضل سعر",
      enterProductName: "يجب إدخال اسم المنتج",
      enterValidQuantity: "يجب إدخال كمية صحيحة",
      loginToContinueRequest: "لتتمة الطلب يرجى التسجيل",
      requestFailed: "فشل في إرسال الطلب",
      validationErrors: "أخطاء في التحقق",
      errorPrefix: "خطأ",
      errorSendingRequest: "حدث خطأ أثناء إرسال الطلب",
      minOrderQuantity: "أقل كمية للطلب: {{count}} وحدة",
      notAvailable: "غير متاح",
      wholesale: "جملة",
      chooseQuantityMsg: "اختر كميتك واحصل على أفضل سعر",
      clickRowMsg: "اضغط على أي صف للاختيار والحصول على الأسعار المفضلة",
      targetQuantity: "الكمية",
      unitPrice: "السعر للوحدة",
      totalPrice: "الإجمالي",
      unit: "وحدة",
      discount: "خصم",
      chooseQuantity: "اختر كميتك",
      savings: "توفير",
      specialPrices: "أسعار خاصة مطبقة",
      andMore: "وأكثر",
      cancel: "إلغاء",
      addToCartWithQty: "أضف للسلة ({{count}} وحدة)",
      createAccountMsg: "أنشئ حسابك لبدء التسوق",
      loginRequired: "يجب تسجيل الدخول",
      loginToCheckout: "يجب تسجيل الدخول لإتمام الطلب",
      sessionExpired: "انتهت الجلسة",
      sessionExpiredMsg: "انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى",
      orderFailed: "فشل في إتمام الطلب",
      orderSuccess: "تم إتمام الطلب بنجاح!",
      orderNumber: "رقم الطلب",
      addItemsToStart: "أضف بعض المنتجات للبدء في التسوق!",
      backToShopping: "العودة للتسوق",
      image: "الصورة",
      itemName: "اسم المنتج",
      action: "إجراء",
      priceAdjusted: "عدل السعر",
      clearCart: "مسح السلة",
      copied: "تم النسخ!",
      linkCopied: "تم نسخ رابط المنتج إلى الحافظة",
      clickToZoom: "انقر للتكبير",
      productVideo: "فيديو المنتج",
      watchVideoDesc: "شاهد المنتج من جميع الزوايا",
      addedToCart: "تمت الإضافة",
      requestForm: "نموذج الطلب",
      requestType: "نوع الطلب",
      supplyRequest: "طلب توريد منتج",
      shippingRequest: "طلب شحن",
      productNamePlaceholder: "أدخل اسم المنتج المطلوب",
      specifications: "المواصفات",
      specificationsPlaceholder: "أدخل مواصفات المنتج (الحجم، اللون، الموديل، إلخ...)",
      requestedQuantity: "الكمية المطلوبة",
      additionalNotes: "ملاحظات إضافية",
      additionalNotesPlaceholder: "أي معلومات إضافية قد تساعدنا في تلبية طلبك...",
      submitRequest: "إرسال الطلب",
      sending: "جاري الإرسال...",
      requestSentSuccess: "تم إرسال الطلب بنجاح!",
      requestSentDesc: "شكراً لك! سيتم مراجعة طلبك والرد عليك قريباً.",
      redirectingToHome: "سيتم توجيهك إلى الصفحة الرئيسية...",
      days: "أيام",
      sourceChina: "توريد من الصين",
      sourceGulf: "توريد من الخليج",
      savedRequestError: "فشل في إرسال الطلب المحفوظ. يرجى المحاولة مرة أخرى.",
      savedRequestErrorGeneric: "حدث خطأ أثناء إرسال الطلب المحفوظ",
      firstNamePlaceholder: "أدخل الاسم الأول",
      lastNamePlaceholder: "أدخل الاسم الأخير",
      userName: "اسم المستخدم",
      userNamePlaceholder: "أدخل اسم المستخدم",
      emailPlaceholder: "أدخل بريدك الإلكتروني",
      mobileNumber: "رقم الجوال",
      countryCode: "مفتاح الدولة",
      saudiArabia: "السعودية",
      sudan: "السودان",
      enterMobileDigits: "أدخل رقم الجوال بدون المفتاح",
      mobileDigitsOnly: "يجب إدخال أرقام فقط",
      mobileLengthInvalid: "عدد الأرقام يجب أن يكون {{count}}",
      notRegisteredPrompt: "فشل الدخول. إذا لم يكن لديك حساب بهذا الرقم، يرجى التسجيل",
      completeRegistration: "إكمال التسجيل",
      mobileOnlyLoginWarning: "ملاحظة: الدخول برقم الجوال فقط أقل أماناً بدون التحقق (OTP). ننصح باستخدام كلمة المرور.",
      mobilePlaceholder: "أدخل رقم الجوال (مثال: 0501234567)",
      passwordRegisterPlaceholder: "أدخل كلمة المرور (6 أحرف على الأقل)",
      confirmPasswordPlaceholder: "أعد إدخال كلمة المرور",
      creatingAccount: "جاري إنشاء الحساب...",
      addNewItem: "إضافة منتج جديد",
      addNewItemToStore: "إضافة منتج جديد للمتجر",
      category: "الصنف",
      item: "المنتج",
      storeInfo: "معلومات المتجر",
      itemAddedSuccess: "تم إضافة المنتج للمتجر بنجاح!",
      step1AddCategory: "الخطوة 1: إضافة صنف جديد",
      categoryName: "اسم الصنف",
      categoryNameEn: "اسم الصنف (إنجليزي)",
      icon: "الأيقونة",
      color: "اللون",
      previousRequests: "الطلبات السابقة",
      requestDate: "التاريخ",
      noRequestsFound: "لا توجد طلبات سابقة",
      previousOrders: "الطلبات السابقة",
      noOrdersFound: "لا توجد طلبات سابقة",
      status: "الحالة",
      quantityError: "خطأ في الكمية",
      minOrderQuantityMessage: "الحد الأدنى للطلب لهذا المنتج هو {{min}}.",
      displayOrder: "ترتيب العرض",
      nextAddItem: "التالي: إضافة منتج",
      step2AddItem: "الخطوة 2: إضافة منتج جديد",
      itemCode: "كود المنتج",
      previous: "السابق",
      nextStoreInfo: "التالي: معلومات المتجر",
      step3StoreInfo: "الخطوة 3: معلومات المنتج في المتجر",
      selectCurrency: "اختر العملة",
      stockQuantity: "الكمية المتوفرة",
      minStockLevel: "الحد الأدنى للمخزون",
      maxStockLevel: "الحد الأقصى للمخزون",
      leadTimeDays: "مدة التوفير (أيام)",
      available: "متوفر",
      featured: "مميز",
      videoUrl: "رابط الفيديو",
      addItemToStoreBtn: "إضافة المنتج للمتجر",
      createCategoryFailed: "فشل في إنشاء الصنف",
      createCategoryError: "حدث خطأ أثناء إنشاء الصنف",
      createItemFailed: "فشل في إنشاء المنتج",
      createItemError: "حدث خطأ أثناء إنشاء المنتج",
      mustCreateItemFirst: "يجب إنشاء منتج أولاً",
      addItemToStoreFailed: "فشل في إضافة المنتج للمتجر",
      addItemToStoreError: "حدث خطأ أثناء إضافة المنتج للمتجر",
      selectPaymentMethod: "اختر طريقة الدفع",
      selectShippingMethod: "اختر طريقة الشحن",
      shippingCost: "تكلفة الشحن",
      subtotal: "المجموع الفرعي",
      paymentFee: "رسوم الدفع",
      totalWithFee: "الإجمالي مع الرسوم",
      easyReturn: "إرجاع سهل",
      within30Days: "خلال 30 يوم من الشراء",
      fetchItemsFailed: "فشل في جلب المنتجات",
      fetchItemsError: "حدث خطأ أثناء جلب المنتجات",
      freeShipping: "شحن مجاني",
      freeShippingDesc: "لجميع الطلبات فوق 500 ر.س",
      buyerProtection: "حماية المشتري",
      qualityGuarantee: "ضمان الجودة والاستبدال",
      customerService247: "خدمة عملاء على مدار الساعة",
      Support: "الدعم الفني",
      startYourRequestNow: "ابدأ طلبك الآن",
      placeOrder: "إتمام الطلب",
      secureCheckout: "دفع آمن",
      loading: "جاري التحميل...",
      actions: "إجراءات",
      ok: "موافق",
      cash: "نقدي",
      // actions: "Actions",
      // ok: "OK",
      retry: "إعادة المحاولة",
      noResults: "لا توجد نتائج",
      noProductsMatch: "لم نجد منتجات تطابق \"{{term}}\"",
      noProductsInStore: "لا توجد منتجات متاحة حالياً في هذا المتجر",
      noProductsInCat: "لا توجد منتجات متاحة حالياً في هذا التصنيف",
      clearSearch: "مسح البحث",
      clearFilter: "إزالة التصفية",
      discoverProducts: "اكتشف مجموعتنا الكاملة من المنتجات",
      discoverCategory: "اكتشف منتجات {{category}}",
      requestNewProduct: "طلب منتج جديد",
      requestNewProductDesc: "اطلب منتج جديد من متجر مايك جرين",
      verifiedSupplier: "مورد معتمد",
      idealForProduction: "خيار مثالي لخطوط الإنتاج",
      customProductRequest: "طلب منتج مخصص",
      yourPartnerInGlobal: "سندكم في اختيار أفضل المنتجات العالمية",
      instantQuote: "عرض سعر فوري خلال 24 ساعة",
      step1Title: "أرسل طلبك",
      step1Desc: "اسم المنتج والمواصفات",
      step2Title: "عرض السعر",
      step2Desc: "نرسل العرض المناسب لك",
      step3Title: "التوريد",
      step3Desc: "نشحن الطلب إلى بابك",
      startOrderNow: "ابدأ طلبك الآن",
      featuredProducts: "منتجات مميزة",
      featuredProductsDesc: "اخترنا لك أفضل المنتجات",
      selectedForYou: "اخترنا لك أفضل المنتجات",
      viewAll: "عرض الكل",
      products: "المنتجات",
      allProducts: "جميع المنتجات",
      sortByNewest: "ترتيب حسب: الأحدث",
      sortByPriceLowToHigh: "ترتيب حسب: السعر (منخفض إلى عالي)",
      sortByPriceHighToLow: "ترتيب حسب: السعر (عالي إلى منخفض)",
      sortByBestSelling: "ترتيب حسب: الأكثر مبيعاً",
      orderType: "نوع الطلب",
      externalOrderType: "طلب خارجي",
      internalOrderType: "طلب داخلي",
      shippingPerItem: "تكلفة الشحن للصنف الواحد",
      shippingDays: "مدة الشحن بالأيام",
      // Item Details
      priceLabel: "السعر",
      regularPrice: "السعر العادي",
      quantityPrices: "أسعار الكميات",
      selectQuantityForBestPrice: "اختر الكمية للحصول على أفضل سعر",
      quantityLabel: "الكمية:",
      unitPriceLabel: "السعر للوحدة:",
      totalPriceLabel: "السعر الإجمالي:",
      quantityHeader: "الكمية",
      unitPriceHeader: "سعر الوحدة",
      totalPriceHeader: "السعر الإجمالي",
      piece: "قطعة",
      quantityDiscountNote: "كلما زادت الكمية، كلما قل سعر الوحدة",
      availableQuantity: "الكمية المتوفرة",
      minimumLimit: "الحد الأدنى",
      minOrderQuantityLabel: "أقل كمية للطلب",
      externalOrderLabel: "طلب خارجي:",
      productAvailableWithin: "سيتم توفير المنتج خلال",
      businessDays: "يوم عمل",
      delivery: "التوصيل",
      within: "خلال",
      payment: "الدفع",
      shareLink: "مشاركة الرابط",
      metaTitle: "MIC Green - حلول التوريد في كل المجالات خاصة الطاقة الشمسية والخضراء",
      metaDesc: "MIC Green – رواد في حلول الطاقة المتجددة والبطاريات",
      metaTwitterTitle: "MIC Green - حلول الطاقة الشمسية والخضراء",
      heroMissionText:`
    نحن
جسركم
التجاري
و
سندكم
في
اختيار
افضل
المنتجات
من
حول
العالم
لنبني
معًا
سودانًا
أجمل
      `
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    // lng: 'en', // Removed to allow language detection
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
